/*
 * TCM guide: paper tabs, the selection shared by the seven figures, the ring.
 * Above 900px a tab shows its plate alone; below, a tab is an anchor. Markup
 * comes from bq-mtc.liquid; the #mtc-chapN anchors are public deep links.
 */
(function () {
  const root = document.querySelector('.bq-mtc');
  if (!root) return;

  const split = window.matchMedia('(min-width: 900px)');
  const tabs = [...root.querySelectorAll('[data-bq-tab]')];
  const panes = [...root.querySelectorAll('[data-bq-pane]')];
  if (!tabs.length) return;

  function show(id) {
    tabs.forEach((tab) => {
      const on = tab.getAttribute('data-bq-tab') === id;
      tab.classList.toggle('is-on', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    panes.forEach((pane) => {
      pane.toggleAttribute('data-bq-off', pane.getAttribute('data-bq-pane') !== id);
    });
  }

  function open(tab, move) {
    const id = tab.getAttribute('data-bq-tab');
    show(id);
    if (move) tab.focus();
    const pane = root.querySelector('[data-bq-pane="' + id + '"]');
    // scroll-margin-top clears the header and the bar, at both widths.
    if (pane) pane.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => open(tab, false));
    tab.addEventListener('keydown', (e) => {
      const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      let next = -1;
      if (step) next = (i + step + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      if (next < 0) return;
      e.preventDefault();
      open(tabs[next], true);
    });
  });

  /* Below 900px the bar follows the reading rather than driving it. */
  const rail = root.querySelector('[data-bq-rail]');
  const spy = new IntersectionObserver(
    (entries) => {
      if (split.matches) return;
      const hit = entries.find((entry) => entry.isIntersecting);
      if (!hit) return;
      const id = hit.target.getAttribute('data-bq-pane');
      const tab = tabs.find((t) => t.getAttribute('data-bq-tab') === id);
      if (!tab || tab.classList.contains('is-on')) return;
      show(id);
      if (rail) rail.scrollTo({ left: Math.max(0, tab.offsetLeft - 16), behavior: 'smooth' });
    },
    { rootMargin: '-25% 0px -70% 0px' }
  );
  panes.forEach((pane) => spy.observe(pane));

  /* The selection, shared by the seven figures. */
  root.querySelectorAll('[data-bq-group]').forEach((group) => {
    const picks = [...group.querySelectorAll('[data-bq-pick]')];
    if (!picks.length) return;
    const marks = [...group.querySelectorAll('[data-bq-def], [data-bq-sec], [data-bq-node], [data-bq-row]')];
    const taiji = group.querySelector('[data-bq-taiji]');
    const ring = group.querySelector('[data-bq-ring]');
    let current = Math.max(0, picks.findIndex((pick) => pick.classList.contains('is-on')));
    // Unwrapped angle, so a turn takes the short way round: Water to Wood is one
    // notch forward, not four back.
    const pas = 360 / picks.length;
    let angle = -pas * current;

    function choose(i) {
      const n = picks.length;
      const ecart = ((((i - current) % n) + n + Math.floor(n / 2)) % n) - Math.floor(n / 2);
      angle -= pas * ecart;
      current = i;
      const key = String(i);
      picks.forEach((pick) => {
        const on = pick.getAttribute('data-bq-pick') === key;
        pick.classList.toggle('is-on', on);
        pick.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      marks.forEach((mark) => {
        const own =
          mark.getAttribute('data-bq-def') ||
          mark.getAttribute('data-bq-sec') ||
          mark.getAttribute('data-bq-node') ||
          mark.getAttribute('data-bq-row');
        mark.classList.toggle('is-on', own === key);
      });
      // The taiji lights one half at a time, neither past its two poles.
      if (taiji) taiji.setAttribute('data-bq-taiji', i < 2 ? key : '');
      if (ring) {
        ring.style.setProperty('--bq-rot', angle + 'deg');
        ring.style.setProperty('--bq-anti', -angle + 'deg');
      }
    }

    picks.forEach((pick) => {
      pick.addEventListener('click', () => choose(+pick.getAttribute('data-bq-pick')));
    });
    group.querySelectorAll('[data-bq-row]').forEach((row) => {
      row.addEventListener('click', () => choose(+row.getAttribute('data-bq-row')));
    });
    group.querySelectorAll('[data-bq-turn]').forEach((button) => {
      button.addEventListener('click', () => {
        choose((current + +button.getAttribute('data-bq-turn') + picks.length) % picks.length);
      });
    });

    /* Swipe on the ring: a pointer shortcut for what the arrows already do. */
    if (ring) {
      let from = null;
      ring.addEventListener('pointerdown', (e) => {
        from = e.clientX;
      });
      ring.addEventListener('pointerup', (e) => {
        if (from === null) return;
        const dx = e.clientX - from;
        from = null;
        if (Math.abs(dx) > 26) choose((current + (dx < 0 ? 1 : -1) + picks.length) % picks.length);
      });
    }
  });

  function fromHash() {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const pane = root.querySelector('[data-bq-pane]#' + CSS.escape(id));
    if (pane) show(pane.getAttribute('data-bq-pane'));
  }

  window.addEventListener('hashchange', fromHash);
  fromHash();
})();
